/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import { useRef, useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Form } from "@unform/web";
import * as Yup from 'yup';

import {
    Container,
    PageContent,
    Text,
    Title,
    Wrap,
    Button
} from "./styles";

import RotateLeftOutlinedIcon from '@material-ui/icons/RotateLeftOutlined';

import { Input, Textarea } from "../../components/Form";

import Header from "../../components/Header";

import { useAuth } from '../../hooks/auth';
import { useToast } from "../../hooks/toast";
import api from "../../services/api";

export function ContatoCriticas() {
    const formRef = useRef(null);
    const [loading, setLoading] = useState(false);

    const history = useHistory();
    const { user } = useAuth();
    const { addToast } = useToast();

    const handleSubmit = useCallback(async (data) => {
        try {
            setLoading(true);

            formRef.current?.setErrors({});

            const schema = Yup.object().shape({
                subject: Yup.string().required('Assunto obrigatório'),
                // Livre (com +DDI) para quem mora fora do Brasil; só exige 8+ números.
                phone: Yup.string()
                    .required('Telefone obrigatório')
                    .test('telefone', 'Digite um telefone válido', (valor) => (valor || '').replace(/\D/g, '').length >= 8),
                text: Yup.string().required('Descrição obrigatória')
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            await api.post('central/common/send-support-email', {
                ...data,
                type: 'SUPPORT'
            });

            addToast({
                type: 'success',
                title: 'Sucesso',
                description: 'Reclamação enviada com sucesso!'
            });

            history.push('/');
        } catch(err) {
            const validationErrors = {};
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
            }
            addToast({
                type: 'error',
                title: 'Erro',
                description: 'Não possível enviar sua reclamação!'
            });
        } finally {
            setLoading(false);
        }
    }, []);

    return (
        <>
            <Container>
                <Header />
                <PageContent>
                    <Text>
                        <p>Está com algum problema específico?</p>
                        <Title>Envie sua crítica ou reclamação para o Cidadania Já</Title>
                    </Text>
                    <Form ref={formRef} onSubmit={(data) => handleSubmit(data)}>
                        <Wrap>
                            <Input
                                name="subject"
                                label="Assunto"
                                required
                            />
                            <Input
                                type="tel"
                                name="phone"
                                label="Telefone (com DDD ou +código do país)"
                                placeholder="(21) 99999-9999 ou +351 912 345 678"
                                required
                            />
                        </Wrap>
                        <Wrap>
                            <Textarea
                                name="text"
                                label="Descreva aqui..."
                                rows="5"
                                required
                            />
                        </Wrap>
                        <Button type="submit" disabled={loading}>
                            {loading ? (
                                <RotateLeftOutlinedIcon className="icon-spin" />
                            ) : (
                                <>
                                    Enviar
                                </>
                            )}
                        </Button>
                    </Form>
                </PageContent>
            </Container>
        </>
    );
}